export default __webpack_public_path__ + "static/media/dwarf_main.07a599d8.gif";